module.exports = __webpack_public_path__ + "static/img/PREordLicm.b0457b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/PREordLicm.jpg
// module id = RJyd
// module chunks = 1